<p-toast key="app-toast" position="top-right" [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}" (onClose)="onToastCerrado($event)"></p-toast>
<p-confirmDialog></p-confirmDialog>
<app-indicador-carga [mostrar]="cargaGlobal()" />
<app-modal-sesion-inactiva />

<router-outlet />